module.exports = __webpack_public_path__ + "img/gegenbauer-dark-logo.95b62c28.svg";